import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useSubscriptionRoutesConditions } from '@pages/Subscriptions/SubscriptionsRoutes'

import { ChartBarIcon } from '@ui/icons/ChartBar.icon'
import { HistoryIcon } from '@ui/icons/History.icon'
import { LayoutIcon } from '@ui/icons/Layout.icon'
import { ShoppingCartIcon } from '@ui/icons/ShoppingCart.icon'

import { TickmillProductType } from '@model/TickmillProductType'

import { MenuSection, useWithMobileIcon } from '../useMenuSections'

export const useSubscriptionsMenu = (): MenuSection => {
  const { t } = useTranslation()
  const { isSubscriptionsVisible } = useSubscriptionRoutesConditions()
  const withMobileIcon = useWithMobileIcon()

  return useMemo(
    () => ({
      id: 'subscriptions',
      label: t('Tabs.Subscriptions'),
      icon: ShoppingCartIcon,
      condition: isSubscriptionsVisible,
      products: [TickmillProductType.ETD],
      children: [
        {
          id: 'trading-platforms',
          label: t('Subscriptions.Trading Platforms'),
          path: '/dashboard/subscriptions/trading-platforms',
          icon: withMobileIcon(LayoutIcon),
        },
        {
          id: 'market-data',
          label: t('Market Data.title'),
          path: '/dashboard/subscriptions/market-data',
          icon: withMobileIcon(ChartBarIcon),
        },
        {
          id: 'history',
          label: t('History'),
          path: '/dashboard/subscriptions/history',
          icon: withMobileIcon(HistoryIcon),
        },
      ],
    }),
    [t, isSubscriptionsVisible, withMobileIcon]
  )
}
